module.exports = __webpack_public_path__ + "img/sc-title.d5b6e03d.png";